//import dependencies (components, styles, scripts etc)
import '../styles/output.css'
import { useRef } from 'react';
//Returns the Top Navigation Bar Component
const NavigationBar=()=>{
    const sideNav=useRef(null);
    const Toggle=useRef(null);
    //The following function opens or closes the side navigation bar for mobile.
    let ToggleNav=()=>{
        let states=['-left-52','left-0'];
        let check=sideNav.current.classList.contains(states[0]);
        if(check){
            sideNav.current.classList.replace(states[0],states[1]);
        }
        else{
             sideNav.current.classList.replace(states[1],states[0]);
        }
        
    }
    return (
        <>
        <div className='main w-screen h-12 flex flex-row sm:justify-between'>
            {/* Logo section if available */}
            <div className='w-1/4 h-full bg-neutral-950 flex flex-row items-center justify-center'>
               <img src='/images/subject/igprof.jpg' alt='' className='size-8 rounded-full'/>
            </div>

            <div className='w-full h-full bg-neutral-950 flex flex-row justify-between items-center'>
               <div className='mx-5 px-10'>
                {/* Navigation for larger screens */}
                <ul className='hidden sm:flex sm:flex-row sm:justify-between'>
                    <li className='text-white font-bold mx-4'>Home</li>
                    <li className='text-white font-bold mx-4'>About</li>
                    <li className='text-white font-bold mx-4'>Work</li>
                    <li className='text-white font-bold mx-4'>Contacts</li>
                </ul>
               </div>
               {/* Menu icon container (For mobile) */}
               <div>
                 <span className='text-white font-bold mr-2 sm:hidden' ref={Toggle} onClick={ToggleNav}>Menu</span>
               </div>
            </div>
        </div>
        {/*Side navigation bar for mobile */}
        <div className='w-52 h-screen fixed top-12 -left-52 bg-neutral-900 transition-all duration-100 ease-linear z-50' id='SideNav' ref={sideNav}>
            <div className='w-full h-full flex flex-col'>
                {/* Brief profile */}
                <div className='w-full flex flex-col items-center p-2'>
                    <img src='/images/subject/igprof.jpg' alt='' className='size-16 rounded-full'/>
                    <h3 className='text-xs text-slate-100 font-semibold'>Roy Clinton</h3>
                    <h3 className='text-xs text-slate-400'>Graphic Designer</h3>
                </div>
                {/* Navigation items */}
                <ul className='flex flex-col pl-3'>
                   <li className='h-9 text-slate-200 font-semibold'>Home</li>
                   <li className='h-9 text-slate-200 font-semibold'>About</li>
                   <li className='h-9 text-slate-200 font-semibold'>Work</li>
                   <li className='h-9 text-slate-200 font-semibold'>Contacts</li>
                </ul>
            </div>
        </div>
        </>
    )
}
export default NavigationBar;